export const BLOCKS = [
    {
        title: 'Поддержка 24/7',
        description: (
            <>
                Мы на связи круглосуточно. Наши инженеры помогут
                с подключением приставки и научат ей пользоваться.
            </>
        ),
    },
    {
        title: 'Movix всегда с вами ',
        description: (
            <>
                Приставка будет работать с любым интернет-провайдером,
                даже при переезде или поездке на дачу.
            </>
        ),
    },
];
